import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "employments",
    defaultRoutePath: "/people/employment",
    menuItemScope: "people",
    menuItemName: "employments",

    routes: [
        {
            path: "/people/employment",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },

        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "carAssociation",
            Component: Wizards.CarAssociation,
        },
        {
            path: "carDissociation",
            Component: Wizards.CarDissociation,
        },
        {
            path: "serviceDissociation",
            Component: Wizards.ServiceDissociation,
        }
    ],

}

export default Module;
